import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ModalCloseAction } from "../../_stores/modal/_actions/modal.actions";
import { Store } from "@ngxs/store";
import { ActivatedRoute, Router } from "@angular/router";
import { RouterSelectors } from "../../_stores/routing/router.selectors";
import { GetHomeworks } from "../../_stores/asignments/_actions/asignments.actions";

@Component({
  selector: 'ui-homework-done',
  templateUrl: './ui-homework-done.component.html',
  styleUrls: ['./ui-homework-done.component.scss']
})
export class UiHomeworkDoneComponent implements OnInit {
  interface: {
    assignment_id: string
  } = {
    assignment_id: null
  }

  constructor(private store: Store,private cdr: ChangeDetectorRef, private route: ActivatedRoute,  private router: Router) { }

  ngOnInit(): void {
    this.initRouteParams();
  }

  initRouteParams(): void {
    this.store.select(RouterSelectors.params).subscribe((_params) => {
      this.interface.assignment_id = _params.assignment_id;
    });
  }

  actionClose():void {
    this.store.dispatch(new ModalCloseAction());
  }

  actionOpenHomework(): void {
    this.store.dispatch(new ModalCloseAction());
    this.store.dispatch(new GetHomeworks());
    this.router.navigate(['homeworks/'+this.interface.assignment_id]).then();
  }
}
